<template>


  <div id='' class='' v-loading=false>

    <el-dialog  class='gDia' :title="$t('app_addPush')" v-model="showDevice" size='middle'>
      <div style='width:100%;background:none;text-align:left;' class='gDiaTable'>

        <el-col :span="6">
          <div style='margin-right:16px;'>
            <MechanismSelector style='' :data="mechanismData"></MechanismSelector>
          </div>
        </el-col>
        <span>
          <el-select @change='tstChange' style='width:16%;margin-right:10px;' v-model="tst" clearable :placeholder="$t('app_status')">
            <el-option
              v-for="item in stModel"
              :key="item.vl"
              :label="item.label"
              :value="item.vl">
            </el-option>
          </el-select>
        </span>


        <el-input
        :placeholder="$t('app_searchTerminal')"
        icon="search"
        @keyup.enter.native='srchDevice'
        style='width:40%;margin-bottom:10px;'
        v-model="iNo">
        </el-input>
      </div>




      <el-table
      :data="tableDvData"
      v-loading='dLoading'
      border
      tooltip-effect="dark"
      style="width: 100%">
        <el-table-column
          align='center'
          prop="terminalNo"
          :label="$t('app_terNo')"
          width="150">
        </el-table-column>
        <el-table-column
          align='center'
          prop="terminalName"
          :label="$t('app_terName')"
          width="130">
        </el-table-column>
        <el-table-column
          prop="terminal_status"
          align='center'
          :label="$t('app_status')"
          width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.terminalStatus == 1 " type="success" size="mini">{{$t('app_online')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 2 " type="danger" size="mini">{{$t('app_offline')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 0 " type="gray" size="mini">{{$t('app_new')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 3 " type="warning" size="mini">{{$t('app_sleep')}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align='center'
          prop="mechName"
          :label="$t('app_distributor')"
          width=''>
        </el-table-column>
        <el-table-column
          prop="operate"
          :label="$t('app_operate')"
          align='center'
          width='80'>
          <template slot-scope='scope'>
            <!-- <el-button   @click='bindOperate(scope.row)' type=text>{{$t('app_push')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_push')" placement="top">
              <el-button type='text' @click='bindOperate(scope.row)'><i class="fa fa-upload" style=""></i></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <div class="gPgDiv" style=''>

        <el-pagination
        @current-change="pageDvSelect"
        @size-change="pageDvSized"
        :current-page="page"
        :page-sizes='$gRows'
        :page-size="$gRow"
        class='gPg'
        layout="total, sizes, prev, pager, next, jumper"
        :total="dvtotal">
        </el-pagination>
        <!-- <el-pagination
          small
          layout="prev, pager, next"
          :total="total">
        </el-pagination> -->

      </div>

    </el-dialog>


    <div class='gPageBorder'>
      <div style='width:calc(100% - 24px);height:100%;background: none;padding-left:24px;padding-bottom:24px;'>
        <div style='height:64px;'>
          <button class='dt-word-main' style='padding:0;height:100%;font-size:22px;background:none;border:none;'>{{detail ? detail.fileName : ''}}</button>
        </div>
        <div style='height:30px;'>
          <table class='dt-pushing'>
            <tr style=''>
              <td >
                <label class='dt-word-title'>{{$t('app_version')}}：</label>
                <label class='dt-word-main'>{{detail? detail.version : ''}}</label>
              </td>
              <td style=''>
                <label class='dt-word-title'>{{$t('app_fileSize')}}：</label>
                <label class='dt-word-main'>{{detail? detail.size : ''}}</label>
              </td>
              <td>
                <label class='dt-word-title'>{{$t('app_distributor')}}：</label>
                <label class='dt-word-main'>{{detail? detail.mechanismName : ''}}</label>
              </td>
              <td>
                <label class='dt-word-title'>{{$t('app_createTime')}}：</label>
                <label class='dt-word-main'>{{detail? detail.createTime : ''}}</label>
              </td>
             
            </tr>
          </table>
        </div>
        <div style='background:none;min-height:10px;display:flex;display:-webkit-flex;'>
          <div class='dt-word-title' style='display:inline-block;min-width:70px;'>
            {{$t('app_skintro')}}：
          </div>
          <div class='dt-word-main' style='display:inline-block;position:relative;background:none;margin: 0 24px 24px 0;'>
            <pre>{{detail? detail.memo : ''}}</pre>
          </div>
        </div>


      </div>
    </div>

    
    <div class='gPageBorder gTopMg'>
      <el-row>
        <el-col :span='16'>
          <el-button class='gSgLeftBtn' @click='allDel'>{{$t('app_mulDel')}} ({{sNum}})</el-button>
          <el-button class='gSgLeftBtn' type='primary'  @click='refreshList'>{{$t('lin_global.shuaxin')}}</el-button>

          <el-button class='gSgLeftBtn' type='primary'  @click='showDevice = true'>{{$t('app_appendpush')}}</el-button>
        </el-col>

        <el-col :span='0'>
          <div class='gSpDiv'></div>
        </el-col>

        
        <el-col :span='4'>
          <div class='gCtrl'><el-input  :placeholder="$t('app_deviceName') + '/' + $t('app_deviceNo')" @keyup.enter.native='query' v-model='tName' icon='search' :on-icon-click='query'></el-input></div>
        </el-col>
        <el-col :span='4'>
          <div class='gSideCtrl'>
            <el-select  v-model="statusVl" clearable :placeholder="$t('app_status')" @change='selectChange'>
              <el-option
                v-for="item in status"
                :key="item.vl"
                :label="item.name"
                :value="item.vl">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>

      <div id='cmData'>
        <el-table
          class='gTopMg'
          ref="multipleTable"
          @row-click='cellClick'
          :data="tableData"
          border
          @selection-change="handleSelectionChange"
          style="width: 100%">
          <el-table-column
              align=center
              type="selection"
              width="55">
          </el-table-column>
          

          <el-table-column
            header-align='center'
            align='center'
            prop="terminalName"
            :label="$t('app_deviceName')"
            width="">
            <template slot-scope='scope'>
              <label style='color:#409EFF;cursor:pointer'>{{scope.row.terminalName}}</label>
              <!-- <label v-show="scope.row.taskStatus == 3 " style='color:green;cursor:pointer'>{{scope.row.terminalName}}</label>
              <label v-show="scope.row.taskStatus == 0 " style='color:orange;cursor:pointer'>{{scope.row.terminalName}}</label>
              <label v-show="scope.row.taskStatus == -1 || scope.row.taskStatus == -5" style='color:red;cursor:pointer'>{{scope.row.terminalName}}</label>
              <label v-show="scope.row.taskStatus != -1 && scope.row.taskStatus != 0 && scope.row.taskStatus != 3 && scope.row.taskStatus != -5" style='color:gray;cursor:pointer'>{{scope.row.terminalName}}</label> -->
            </template>
          </el-table-column>

          <el-table-column
            header-align='center'
            align='center'
            prop="terminalNo"
            :label="$t('app_deviceNo')"
            width="">
            <template slot-scope='scope'>
              <label style='color:#409EFF;cursor:pointer'>{{scope.row.terminalNo}}</label>
              <!-- <label v-show="scope.row.taskStatus == 3 " style='color:green;cursor:pointer'>{{scope.row.terminalNo}}</label>
              <label v-show="scope.row.taskStatus == 0 " style='color:orange;cursor:pointer'>{{scope.row.terminalNo}}</label>
              <label v-show="scope.row.taskStatus == -1 || scope.row.taskStatus == -5 " style='color:red;cursor:pointer'>{{scope.row.terminalNo}}</label>
              <label v-show="scope.row.taskStatus != -1 && scope.row.taskStatus != 0 && scope.row.taskStatus != 3 && scope.row.taskStatus != -5" style='color:gray;cursor:pointer'>{{scope.row.terminalNo}}</label> -->
            </template>
          </el-table-column>

          <el-table-column
            header-align='center'
            align='center'
            prop="progress"
            :label="$t('app_process')"
            width="">
            <template slot-scope='scope'>
              <label>{{scope.row.data ? scope.row.data.result.progress : scope.row.progress}} %</label>
            </template>
          </el-table-column>

          <el-table-column
            header-align='center'
            align='center'
            :label="$t('app_status')"
            width="">
            <template slot-scope='scope'>
              
              <!-- <label>{{statusNames[scope.row.taskStatus]}}</label> -->
              <label v-show="scope.row.taskStatus == 3 || scope.row.taskStatus == 5 || scope.row.taskStatus == -3  " style='color:green;cursor:pointer'>{{statusNames[scope.row.taskStatus]}}</label>
              <label v-show="scope.row.taskStatus == 0 " style='color:orange;cursor:pointer'>{{statusNames[scope.row.taskStatus]}}</label>
              <label v-show="scope.row.taskStatus == -1 || scope.row.taskStatus == -5 || scope.row.taskStatus == -10 " style='color:red;cursor:pointer'>{{statusNames[scope.row.taskStatus]}}</label>
              <label v-show="scope.row.taskStatus != -1 && scope.row.taskStatus != 0 && scope.row.taskStatus != 3 && scope.row.taskStatus != -5  && scope.row.taskStatus != -10 && scope.row.taskStatus != 5 && scope.row.taskStatus != -3" style='color:gray;cursor:pointer'>{{statusNames[scope.row.taskStatus]}}</label>
            </template>
          </el-table-column>

          <el-table-column
            header-align='center'
            align='center'
            prop="terminalNo"
            :label="$t('app_pushTime')"
            width="">
            <template slot-scope='scope'>
              <label>{{scope.row.createTime}}</label>
            </template>
          </el-table-column>

          <el-table-column
            header-align='center'
            align=center
            prop="cancelNums"
            :label="$t('app_operate')"
            width="116">
            <template slot-scope='scope'>
              
              

              <!-- <el-button  type=text v-show='showBtn(1, scope.row.status)' @click='downOperate(2, scope.row)'>{{$t('app_pause')}}</el-button> -->
              <el-tooltip class="item" effect="dark" :content="$t('app_pause')" placement="top">
                <el-button type='text' v-show='showBtn(1, scope.row.taskStatus)' @click='downOperate(2, scope.row)'><i class="fa fa-pause" style=""></i></el-button>
              </el-tooltip>

              <!-- <el-button type=text v-show='showBtn(2, scope.row.status)' @click='downOperate(1, scope.row)'>{{$t('app_continue')}}</el-button> -->
              <el-tooltip class="item" effect="dark" :content="$t('app_continue')" placement="top">
                <el-button type='text' v-show='showBtn(2, scope.row.taskStatus)' @click='downOperate(1, scope.row)'><i class="fa fa-play" style=""></i></el-button>
              </el-tooltip>

              <!-- <el-button type=text v-show='showBtn(3, scope.row.status)' @click='downOperate(3, scope.row)'>{{$t('app_cancel')}}</el-button> -->
              <el-tooltip class="item" effect="dark" :content="$t('app_ccdown')" placement="top">
                <el-button type='text' v-show='showBtn(3, scope.row.taskStatus)' @click='downOperate(3, scope.row)'><i class="fa fa-window-close" style=""></i></el-button>
              </el-tooltip>

              <el-tooltip class="item" effect="dark" :content="$t('lin_global.chongtui')" placement="top">
                <el-button type='text' v-show='showBtn(4, scope.row.taskStatus)' @click='repush(scope.row)'><i class="fa fa-repeat" style=""></i></el-button>
              </el-tooltip>


              <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
                <el-button type='text' v-show='showBtn(0, scope.row.taskStatus)' @click='delRow(scope.row)'><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
              </el-tooltip>

            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class='gPgDiv'>


        <el-pagination
          class='gPg'
          @current-change="pageSelect"
          @size-change="pageSized"
          :current-page="index"
          :page-sizes='$gRows'
          :page-size="row"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
          </el-pagination>
      </div>
    </div>
  </div>
</template>

<style>
.dt-pushing{background:none;width:100%;}
</style>

<script>
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default{
    components: {
      MechanismSelector
    },
    data () {
      var that = this
      return {
        dLoading: false,
        tst: '',
        iNo: '',
        mechanismData: {
          callback (value) {
            that.mech = value
            that.getCmDv()
          }
        },
        stModel: [
          {label: this.$t('app_online'), vl: '1'},
          {label: this.$t('app_offline'), vl: '2'},
          {label: this.$t('app_sleep'), vl: '3'},
          // {label: '锁定', vl: '2'}
        ],
        showDevice: false,
        mech: '',
        sNum: 0,
        index: 1,
        page: 1,
        refresh: 6000,
        multipleSelection: [],
        name: '',
        tContent: '',
        row: this.$gRow,
        total: 0,
        dvtotal: 0,
        dialogFormVisible: 0,
        tableData: [],
        tableDvData: [],
        pInfo: [], // 进度处理
        loading: 0,
        editData: '',
        info: '',
        detail: '',
        statusNames: { // add by sing, 2017-06-17
          '-1': this.$t('app_downFail'),
          '-2': this.$t('app_md5Fail'),
          '-3': this.$t('app_theNewgVer'),
          '-4': this.$t('app_fileFmIllegal'),
          '-5': this.$t('app_updateFail'),
          '-6': this.$t('app_usrCancelUpdate'),
          '0': this.$t('app_pushFail'),
          '1': this.$t('app_downloading'),
          '2': this.$t('app_downFinish'),
          '3': this.$t('app_success'),
          '4': this.$t('app_waiting'),
          '5': this.$t('app_success'),
          '6': this.$t('app_pause'),
          '7': this.$t('app_ccdown'),
          '-7': this.$t('app_verror'),
          '-8': this.$t('app_insfail'),
          '-9': this.$t('app_checksignfail'),
          '-10': this.$t('app_uninsfail'),
        },
        status: [
          {vl: '-1', name: this.$t('app_downFail')},
          {vl: '-2', name: this.$t('app_md5Fail')},
          {vl: '-3', name: this.$t('app_newgVer')},
          {vl: '-4', name: this.$t('app_fileFmIllegal')},
          {vl: '-5', name: this.$t('app_updateFail')},
          {vl: '-6', name: this.$t('app_usrCancelUpdate')},
          {vl: '0', name: this.$t('app_pushFail')},
          {vl: '1', name: this.$t('app_downloading')},
          {vl: '2', name: this.$t('app_downFinish')},
          {vl: '3', name: this.$t('app_success')},
          {vl: '4', name: this.$t('app_waiting')},
          {vl: '5', name: this.$t('app_success')},
          {vl: '6', name: this.$t('app_pause')},
          {vl: '7', name: this.$t('app_ccdown')},
          {vl: '-7', name: this.$t('app_verror')},
          {vl: '-8', name: this.$t('app_insfail')},
          {vl: '-9', name: this.$t('app_checksignfail')},
          {vl: '-10', name: this.$t('app_uninsfail')},

        ],
        statusVl: '',
        tName: ''
      }
    },
    computed: {
      /* index () {
        return this.$getWPage('missionDetailPage')
      } */
    },
    methods: {
      tstChange () {
        this.getCmDv()
      },
      bindOperate (row) {
        this.dLoading = 1
        var mc = row.mechId // row.mechId
        this.$appendPush(this.info.taskId, row.terminalNo, '1', mc, row.terminalNo, '', '','','', (res) => {
          this.dLoading = 0
          if (res.status === 200) {
            this.$message.success(this.$t('app_tipViewTask'))
            this.notPassDialog = false
            this.getList()
          } else {
            this.$message.error(res.message)
          }
        }, (error) => {
          this.dLoading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      srchDevice () {
        this.getCmDv()
      },
      getCmDv () {
        if (this.info.taskType == '14' || this.info.taskType == '14') {
          this.getNonDevices()
        } else {
          this.getDevices()
        }
      },
      getDevices () {

        var channel = this.mech ? this.mech : ''
        var terminalNo = this.iNo ? this.iNo : ''
        var status = this.tst ? this.tst : ''
   
        var mFileId,fileId,fileType


        this.loading = 1
        this.$canPushTer(this.page, this.$gRow, mFileId, channel, status, terminalNo, fileType, fileId, (res) => {
          console.log('res', res)
          this.loading = 0
          if (res.data) {
            this.dvtotal = res.total
            this.tableDvData = res.data

            var _this = this
            var tsl = this.batchSl[this.index - 1]
            if (tsl) {
              var tm = []
              tsl.forEach((vl) => {
                res.data.forEach((vl1) => {
                  if (vl.terminalNo == vl1.terminalNo)
                  {
                    tm.push(vl1)
                  }
                })
              })
              setTimeout(() => {
                _this.toggleSelection(tm)
              },100)
            }
          }
        }, () => {
          // error
          this.loading = 0
        })
        
        
      },
      getNonDevices () {
        var channel = this.mech ? this.mech : ''
        var terminalNo = this.iNo ? this.iNo : ''
        var status = this.tst ? this.tst : ''
        //var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid


        var mFileId,fileId,fileType

    

        this.loading = 1
        this.$getNonItDv(this.page, this.$gRow, channel, terminalNo, status,'','','','','', (res) => {
          
          this.loading = 0
          if (res.data) {
            this.tableDvData = res.data
            this.dvtotal = res.total
          }
        }, () => {
          // error
          this.loading = 0
        })
        
      },
      refreshList () {
        this.getList()
      },
      repush (row) {
        //console.log(row)
        this.$pushRepush(row.id, (res) => {
          // this.delDeviceNo = 0
          this.loading = 0
          if (res.status === 200) {
            this.$message.success(res.message)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          // error
        })
        
      },
      cellClick (row, ev, col) {
        if (col.label && col.label === this.$t('app_operate')) {
          return
        }

        if (col.label === this.$t('app_deviceName') || col.label === this.$t('app_deviceNo')) {
          
          /*var obj={
            terId:row.terminalId,
            terNo:row.terminalNo,
            ter: row
          } 
          this.$store.dispatch('setTerParam',obj)*/

          if (this.detail.fileType == 6) {
            this.$setWObj('ndObj', {data:row.terminalId}) 
            this.$router.push({path: '/non-it-eq/device/detail'})
          } else {
            this.$router.push({
              path: '/terList/' + row.terminalId + '/details'
            })
          }

          // console.log(this.detail)
        }

       

        //this.$setWObj('editAppConfig', cf)
        //this.$router.push({name: this.$t(name)})
      },
      /* processFinish () {
        clearTimeout(this.fTm)
        this.fTm = setInterval(() => {
          var is = 0
          this.tableData.forEach((vl) => {
            if (vl.status === '2') {
              //...
              is = 1
            }
          })
          if (is) {
            this.getList()
          } else {
            clearTimeout(this.fTm)
          }
        }, this.refresh)
      }, */
      allDel () {
        var hit = 0
        this.multipleSelection.forEach((vl) => {
          if (vl.status === '1' ||
          vl.status === '1' ||
          vl.status === '6') {
            hit = 1
            return
          }
        })
        if (hit) {
          this.$message.error(this.$t('app_cantDelTask'))
        } else {
          var ids = ''
          this.multipleSelection.forEach((vl) => {
            ids += vl.id + ','
          })
          ids = ids.substring(0, ids.length - 1)
          if (!ids) {
            this.$message(this.$t('app_oneRecordMust'))
            return
          }
          this.loading = 1
          this.$pushDelTask(ids, (res) => {
            // this.delDeviceNo = 0
            this.loading = 0
            if (res.status === 200) {
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
            // error
          })
        }
      },
      handleSelectionChange (val) {
        this.sNum = val.length
        this.multipleSelection = val
        if (this.multipleSelection.length > 0) {
          this.stopTimer()
        } else {
          this.updateTimer()
        }
      },
      query () {
        this.getList()
      },
      selectChange (vl) {
        this.getList()
      },
      downOperate (vl, row) {
        console.log(row.terminalNo)
        this.loading = 1
        this.$pushFileDownCtrl(row.id, vl + '', row.terminalNo, (res) => {
          console.log('opres', res)
          this.loading = 0
          if (res.status === 200) {
            this.getList()
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          // error
        })
      },
      getProcess (mIds) {
        if (!mIds) {
          this.stopTimer()
          return
        }
        //console.log(this.$route.path)
        
        this.$missionPersent(mIds, (res) => {
          if (res.status === 200) {
            //console.log(res)
            var temp = []
            this.pInfo.forEach((vl, index) => {
              var newData = vl
              var data = res.data[index]
              if (data.result) {
                // taskStatus
                newData.value.progress = data.result.progress
                newData.value.status = data.result.status
                newData.value.taskStatus = data.result.status
                var st = data.result.status
                if (st != 1 && st != 2 && st != 4) {
                  this.getList()
                }
              } else {
                this.getList()
              }
              temp.push(newData)
            })
            this.pInfo = temp
            // 把数据贴到缓存中

            this.pInfo.forEach((vl, index) => {
              this.tableData[vl.index] = vl.value
            })
            // 数据更新完成
            // console.log(res)
            // console.log(this.tableData)


          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
        })
      },
      processCore () {
        var arr = this.tableData
        this.pInfo = []
        this.tableData.forEach((vl, index) => {
          if (vl.taskStatus === '1' || vl.taskStatus === '2' || vl.taskStatus === '4') {
            this.pInfo.push({value: vl, index: index})
          }
        })
        var ids = ''
        this.pInfo.forEach((vl, index) => {
          ids += vl.value.id + ','
        })
        ids = ids.substring(0, ids.length - 1)
        this.getProcess(ids)
      },
      updateTimer () {
        this.stopTimer()

        if (this.$route.path !== '/mission-detail') {
          return
        }
        this.pTm = setInterval(() => {
          // console.log('tm go')
          this.processCore()
        }, this.refresh)
      },
      stopTimer () {
        clearInterval(this.pTm)
        clearTimeout(this.pTm)
        //console.log(this.pTm, this.fTm)
      },
      showBtn (tag, st) {
        // tag 0删除 1暂停 2继续 3取消 4重推
        // st (0失败、1正在下载、2暂停、3取消、4完成)
        // 新状态，modify by sing, 2017-06-17
        // st -1： 下载失败， -2： MD5校验失败， -3： 已经是最新版本，
        // -4： 文件格式不正确（不是apk文件）， -5： 更新失败，-6：用户取更，
        // 1： 下载中，返回下载进度，2： 下载完成， 3： 更新成功，6暂停 7取消
        var vl = st;
        // console.log('tag is ' + tag + ',status: ' + JSON.stringify(st));
        switch (vl) {
          case '-1':
          case '-2':
          case '-3':
          case '-4':
          case '-5':
          case '-6':
          case '-7':
          case '-8':
          case '-9':
          case '3':
          case '4':
          case '2':
          case '0':
          case '7':
            if (tag === 0) {
              return 1
            } else if (tag === 4)  {
              if (vl === '-1' || vl === '-2' || vl === '-5') {
                return 1
              } else {
                return 0
              }
            }  else {
              return 0
            }
            break
          case '1':
            if (tag === 1 || tag === 3) {
              return 1
            } else {
              return 0
            }
            break
          case '6':
            if (tag === 2) {
              return 1
            } else {
              return 0
            }
            break
        }
        //updateTimer
      },
      delRow (row) {
        this.$showConfirm('', this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warnning', () => {
          // sure
          //console.log(row)
          var id = row.id
          this.loading = 1
          this.$pushDelTask(id, (res) => {
            // this.delDeviceNo = 0
            this.loading = 0
            if (res.status === 200) {
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
            // error
          })
        })
        // console.log(row)
      },
      pageSelect (index) {
        this.index = index
        this.getList()
        // this.$setWPage('missionDetailPage', index)
      },
      pageSized (val) {
        this.$gRow = val
        this.getCmDv()
      },
      pageDvSelect (index) {
        this.page = index
        this.getCmDv()
      },
      pageDvSized (val) {
        this.$gRow = val
        this.getList()
      },
      getList () {
        var tNameVl = this.tName ? this.tName : ''
        var statusVl = this.statusVl ? this.statusVl : ''
        var content = this.tContent? this.tContent : ''
        this.loading = 1
        
        this.$pushTaskDetail(tNameVl, statusVl, this.index, this.$gRow, this.info.taskId, (res) => {
          this.loading = 0
          if (res.status === 200) {
            //console.log(res.data)
            this.tableData = res.data
            this.total = res.total
            this.updateTimer() 
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      getDetail () {
        this.loading = true
        this.$pushFileDetail(this.info.fileId, this.info.taskType, (res) => {
          this.loading = false
          if (res.status === 200) {
            //console.log(res.data)
            this.detail = res.data
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = false
        })
      }
    },
    mounted () { 
      this.info = this.$getWObj().missionInfo
      console.log('info', this.info)

      this.getCmDv()
  
      this.getList()
      this.getDetail()
    },
    destroyed () {
      this.stopTimer()
      
    }
  }
</script>



// WEBPACK FOOTER //
// detail.vue?f6794a5a